import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * DemoBanner — shown when the user is in demo mode.
 *
 * Renders a prominent amber bar so users always know they are looking
 * at sample data, not their real business data.
 */
export default function DemoBanner() {
  const { isDemo, demoSessionsRemaining } = useAuth();
  const navigate = useNavigate();

  if (!isDemo) return null;

  return (
    <div className="demo-banner">
      <div className="demo-banner__left">
        <span className="demo-banner__badge">Demo Mode</span>
        <span className="demo-banner__text">
          You're viewing sample data — this is <strong>not</strong> your real business data.
          {demoSessionsRemaining != null && (
            <span className="demo-banner__sessions">
              {' '}{demoSessionsRemaining} demo session{demoSessionsRemaining !== 1 ? 's' : ''} remaining today.
            </span>
          )}
        </span>
      </div>
      <button
        className="demo-banner__cta"
        onClick={() => navigate('/select-store?create=1')}
      >
        Create your store →
      </button>
    </div>
  );
}
